import { render, staticRenderFns } from "./LightingPage.vue?vue&type=template&id=657d3834&"
import script from "./LightingPage.vue?vue&type=script&lang=js&"
export * from "./LightingPage.vue?vue&type=script&lang=js&"
import style0 from "./LightingPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports